// React
import React from "react";
import PropTypes from "prop-types";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Action
import { showModal } from "../../../actions/ui";

// Libs
import { Row, Col } from "react-bootstrap";

// Components
import PartnerApp from "./PartnerApp";
import Container from "../../component/Container";

// Static Data
import staticData from "./staticData";

// Style
import "./Section.css";

/**
  We are using typeSection to select what data will show up into the section.
  The <Section /> component have the props type="" required.
  ex: <Section type="marketing"/> will get the data like this typeSection[type]
 */
const typeSection = {
  ...staticData.sections
};

const Section = ({ type, showModal }) => {
  // header and apps are keys inside of our staticData.js
  const { header, apps } = typeSection[type];

  return (
    <Row>
      <Col md={12} style={{ marginBottom: "15px" }}>
        <PartnerApp
          title={header.title}
          subtitle={header.subtitle}
          img={header.img}
          type="title"
        />
      </Col>

      {apps.map((app, index) => {
        return (
          <Col md={6} key={index}>
            <Container
              theme="dropShadow"
              style={{ minHeight: "200px" }}
              onClick={() => showModal("SPOCKET_DEALS", { app })}
            >
              <div className="section__header">
                {app.storeLogo &&
                  app.storeLogo.map((logo, index) => {
                    return <img src={logo} key={index} alt="Title" />;
                  })}
              </div>

              <PartnerApp
                name={app.name}
                title={app.title}
                subtitle={app.subtitle}
                img={app.img}
                storeLogo={app.storeLogo}
                type="description"
              />
            </Container>
          </Col>
        );
      })}
    </Row>
  );
};

Section.propTypes = {
  type: PropTypes.string.isRequired
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showModal }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(Section);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/spocketDeals/Section.js